'use client';
import { __rest } from 'tslib';
import React, { forwardRef } from 'react';
import { styled } from '../stitches.config.js';
import * as ToggleGroupPrimative from '@radix-ui/react-toggle-group';

const ToggleGroup = forwardRef((_a, ref) => {
    var { items, id, error } = _a, fields = __rest(_a, ["items", "id", "error"]);
    return (React.createElement(Flex, null,
        React.createElement(ToggleGroupRoot, Object.assign({}, fields, { ref: ref, id: id }), items.map(item => React.createElement(ToggleItem, { style: item.style, key: item.value, value: item.value }, item.label))),
        error));
});
ToggleGroup.displayName = 'ToggleGroup';
const MultiToggleGroup = (_a) => {
    var { items, id } = _a, field = __rest(_a, ["items", "id"]);
    return (React.createElement(ToggleGroupRoot, Object.assign({}, field, { id: id, type: 'multiple' }), items.map(item => React.createElement(ToggleItem, { key: item.value, value: item.value }, item.label))));
};
const ToggleItem = styled(ToggleGroupPrimative.Item, {
    all: 'unset',
    backgroundColor: '$gray1',
    color: '$outline',
    // height: 35,
    // width: 35,
    padding: '0.5rem 0.75rem',
    flex: '1',
    display: 'flex',
    fontSize: 15,
    lineHeight: 1,
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 1,
    '&:first-child': { marginLeft: 0, borderTopLeftRadius: 4, borderBottomLeftRadius: 4 },
    '&:last-child': { borderTopRightRadius: 4, borderBottomRightRadius: 4 },
    '&:hover': { backgroundColor: '$primary3' },
    '&[data-state=on]': { backgroundColor: '$primary5', color: '$primary11' },
    '&:focus': { position: 'relative', boxShadow: `$focus` },
});
const ToggleGroupRoot = styled(ToggleGroupPrimative.Root, {
    display: 'inline-flex',
    backgroundColor: '$gray6',
    borderRadius: 4,
    boxShadow: `rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 1px 1px`,
    // boxShadow: '$boxShadow'
    // boxShadow: `rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px`,
    // flexBasis: '40%',
    // flex: 1
});
const Flex = styled('div', {
    all: 'unset',
    flexGeneral: 'column'
});

export { MultiToggleGroup, ToggleGroup, ToggleGroupRoot, ToggleItem };
